__webpack_require__.p = "https://bicycode.ocode.bike/";